__turbopack_context__.v({
  "actions": "home-module__06co2W__actions",
  "ai": "home-module__06co2W__ai",
  "aiBand": "home-module__06co2W__aiBand",
  "aiGrid": "home-module__06co2W__aiGrid",
  "aiSymbol": "home-module__06co2W__aiSymbol",
  "aiWorkflow": "home-module__06co2W__aiWorkflow",
  "brand": "home-module__06co2W__brand",
  "button": "home-module__06co2W__button",
  "car": "home-module__06co2W__car",
  "container": "home-module__06co2W__container",
  "eyebrow": "home-module__06co2W__eyebrow",
  "feature": "home-module__06co2W__feature",
  "featureAside": "home-module__06co2W__featureAside",
  "featuredSolution": "home-module__06co2W__featuredSolution",
  "features": "home-module__06co2W__features",
  "featuresLayout": "home-module__06co2W__featuresLayout",
  "food": "home-module__06co2W__food",
  "footer": "home-module__06co2W__footer",
  "hero": "home-module__06co2W__hero",
  "heroBadge": "home-module__06co2W__heroBadge",
  "heroContent": "home-module__06co2W__heroContent",
  "heroCopy": "home-module__06co2W__heroCopy",
  "heroFlow": "home-module__06co2W__heroFlow",
  "heroFood": "home-module__06co2W__heroFood",
  "heroImage": "home-module__06co2W__heroImage",
  "heroMore": "home-module__06co2W__heroMore",
  "heroTags": "home-module__06co2W__heroTags",
  "home": "home-module__06co2W__home",
  "house": "home-module__06co2W__house",
  "integrationChannel": "home-module__06co2W__integrationChannel",
  "integrationFallback": "home-module__06co2W__integrationFallback",
  "integrationGroup": "home-module__06co2W__integrationGroup",
  "integrationLogo": "home-module__06co2W__integrationLogo",
  "integrationTrack": "home-module__06co2W__integrationTrack",
  "integrationViewport": "home-module__06co2W__integrationViewport",
  "integrationsBand": "home-module__06co2W__integrationsBand",
  "integrationsContent": "home-module__06co2W__integrationsContent",
  "integrationsEyebrow": "home-module__06co2W__integrationsEyebrow",
  "integrationsHeadline": "home-module__06co2W__integrationsHeadline",
  "integrationsScroll": "home-module__06co2W__integrationsScroll",
  "intro": "home-module__06co2W__intro",
  "lightButton": "home-module__06co2W__lightButton",
  "miniStore": "home-module__06co2W__miniStore",
  "outlineButton": "home-module__06co2W__outlineButton",
  "primaryButton": "home-module__06co2W__primaryButton",
  "renaveBand": "home-module__06co2W__renaveBand",
  "renaveEyebrow": "home-module__06co2W__renaveEyebrow",
  "renaveFlowCard": "home-module__06co2W__renaveFlowCard",
  "renaveFlowLine": "home-module__06co2W__renaveFlowLine",
  "renaveHomeCopy": "home-module__06co2W__renaveHomeCopy",
  "renaveHomeGrid": "home-module__06co2W__renaveHomeGrid",
  "renaveHomeVisual": "home-module__06co2W__renaveHomeVisual",
  "renaveLink": "home-module__06co2W__renaveLink",
  "renaveStatus": "home-module__06co2W__renaveStatus",
  "search": "home-module__06co2W__search",
  "section": "home-module__06co2W__section",
  "sectionHeading": "home-module__06co2W__sectionHeading",
  "solution": "home-module__06co2W__solution",
  "solutionBadge": "home-module__06co2W__solutionBadge",
  "solutionBody": "home-module__06co2W__solutionBody",
  "solutionIcon": "home-module__06co2W__solutionIcon",
  "solutionVisual": "home-module__06co2W__solutionVisual",
  "solutions": "home-module__06co2W__solutions",
  "store": "home-module__06co2W__store",
  "supplier": "home-module__06co2W__supplier",
  "supplierCarousel": "home-module__06co2W__supplierCarousel",
  "supplierLogo": "home-module__06co2W__supplierLogo",
  "suppliers": "home-module__06co2W__suppliers",
  "textLink": "home-module__06co2W__textLink",
  "workflowTitle": "home-module__06co2W__workflowTitle",
});
